// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "0f78112299a15b68dfc9370573671882b2b7472b/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};